// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"1802a1e91e10dc6673fc","293":"c3f37912ced7a16c7361","461":"bad37ab0d297819b2e95","518":"dfb644021f2340e3e0ac","779":"48a8d54c61c660ce1096"}[chunkId] + ".js";
};